
import Checkbox from '@mui/material/Checkbox'

import React, { Fragment as F, useContext, useEffect, useState } from 'react'

import Modal from 'react-modal'

import {
  appRouter,
  C,
  logg, loggt,
  useApiRouter,
} from '$shared'
import {
  AppCtx,
} from '$src/App'
import {
  QueriesCtx,
} from '$src/components/queries'

/*
 * FiltersBox
**/
const FiltersBox = (props) => {
  // logg(props, 'FiltersBox')

  /* ctx */

  const {
    customerId,
    loading,    setLoading,
    selectedResource, setSelectedResource, defaultSelectedResource,
    scope,      setScope,
  } = useContext(AppCtx)
  // logg(useContext(AppCtx), 'AppCtx in FiltersBox')

  const {
    selectedQueries,    setSelectedQueries,
  } = useContext(QueriesCtx)

  /* methods */

  // @TODO: (1) make this a required prop, and (2) move this default to the ?only place it's used.
  let onChange = () => {
    setSelectedQueries({})
  }
  if (props.onChange) {
    onChange = props.onChange
  }

  return <div className='FiltersBox'>
    <label className='label-main' >Filters</label>
    <div className='FiltersBoxC'>
      <Checkbox
        checked={!!scope[C.scope.mine]}
        onChange={(ev) => {
          onChange(ev)
          if (scope[C.scope.mine]) {
            delete scope[C.scope.mine]
          } else {
            scope[C.scope.mine] = true
          }
          setScope({...scope})
        }}
      /><label>Mine</label>
      <Checkbox
        checked={!!scope[C.scope.standard]}
        onChange={(ev) => {
          onChange(ev)
          if (scope[C.scope.standard]) {
            delete scope[C.scope.standard]
          } else {
            scope[C.scope.standard] = true
          }
          setScope({...scope})
        }}
      /><label>Standard</label>
      <Checkbox
        checked={!!scope[C.scope.company]}
        onChange={(ev) => {
          onChange(ev)
          if (scope[C.scope.company]) {
            delete scope[C.scope.company]
          } else {
            scope[C.scope.company] = true
          }
          setScope({...scope})
        }}
      /><label>Company</label>
      <Checkbox
        checked={!!scope[C.scope.shared]}
        onChange={(ev) => {
          onChange(ev)
          if (scope[C.scope.shared]) {
            delete scope[C.scope.shared]
          } else {
            scope[C.scope.shared] = true
          }
          setScope({...scope})
        }}
      /><label>Shared with me</label>
    </div>
  </div>

}
export default FiltersBox
